import { FileDown, Loader2 } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { downloadBlob, errMsg, http } from "../../lib/api";
import { Btn } from "../kit/Kit";
import { CAT, inp } from "./common";

const MODS = ["auth", "equipo", "loan_management", "expedientes", "expedientes_credito", "tasks", "cnbv", "comisiones", "cobranza", "trafalgar_ai", "auditoria", "ticker", "backups", "liquidez", "reportes"];

export const Filtros = ({ f, setF, fijo, usuarios }) => {
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  return (
    <div className="grid grid-cols-2 gap-2 md:grid-cols-4 xl:grid-cols-8" data-testid="bit-filtros">
      <select value={f.actor} onChange={set("actor")} className={inp} data-testid="bit-f-usuario"><option value="">Todos los usuarios</option>{usuarios.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}</select>
      <input type="date" value={f.desde} onChange={set("desde")} className={inp} data-testid="bit-f-desde" aria-label="Desde" />
      <input type="date" value={f.hasta} onChange={set("hasta")} className={inp} data-testid="bit-f-hasta" aria-label="Hasta" />
      <select value={f.modulo} onChange={set("modulo")} className={inp} data-testid="bit-f-modulo"><option value="">Todos los módulos</option>{MODS.map((m) => <option key={m}>{m}</option>)}</select>
      <select value={fijo ?? f.categoria} disabled={!!fijo} onChange={set("categoria")} className={inp} data-testid="bit-f-categoria"><option value="">Todas las categorías</option>{Object.entries(CAT).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
      <select value={f.resultado} onChange={set("resultado")} className={inp} data-testid="bit-f-resultado"><option value="">Todo resultado</option><option value="ok">ok</option><option value="error">error</option><option value="denegado">denegado</option></select>
      <input placeholder="IP" value={f.ip} onChange={set("ip")} className={inp} data-testid="bit-f-ip" />
      <label className="flex items-center gap-2 rounded-lg border border-[#E2DDD5] bg-white px-3 py-2 text-sm" data-testid="bit-f-qa-label">
        <input type="checkbox" checked={f.qa} onChange={set("qa")} data-testid="bit-f-qa" />Incluir eventos QA</label>
    </div>
  );
};

export const params = (f, fijo) => {
  const p = { qa: f.qa, categoria: fijo ?? f.categoria, modulo: f.modulo, resultado: f.resultado, ip: f.ip.trim(), actor: f.actor };
  if (f.desde) p.desde = new Date(`${f.desde}T00:00:00-06:00`).toISOString();
  if (f.hasta) p.hasta = new Date(`${f.hasta}T23:59:59-06:00`).toISOString();
  return Object.fromEntries(Object.entries(p).filter(([, v]) => v !== "" && v !== undefined));
};

export const Paquete = ({ p }) => {
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const go = async () => {
    setBusy(true);
    try {
      const { qa, ...filtros } = p;
      const r = await http.post("/audit/paquete", { filtros, qa: !!qa });
      setRes(r.data);
      await downloadBlob(`/audit/paquete/${r.data.id}/xlsx`, `Paquete_auditor_${r.data.id}.xlsx`);
      await downloadBlob(`/audit/paquete/${r.data.id}/pdf`, `Paquete_auditor_${r.data.id}.pdf`);
      toast.success(`Paquete generado: ${r.data.registros} registros`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-col items-start gap-1">
      <Btn kind="accent" onClick={go} disabled={busy} data-testid="bit-paquete-btn">{busy ? <Loader2 size={15} className="animate-spin" /> : <FileDown size={15} />}Paquete para auditor</Btn>
      {res && <p className="max-w-full break-all text-[11px] text-[#5C5850]" data-testid="bit-paquete-res">{res.nota_qa} SHA-256 Excel {res.sha256_xlsx.slice(0, 16)}… · PDF {res.sha256_pdf.slice(0, 16)}…</p>}
    </div>
  );
};
